import { tBillPayService } from "src/app/services/tBillPay.service";
import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LoggerService } from "src/app/services/Non-Master/logger.service";
import { MatPaginator, MatTableDataSource, MatSort } from "@angular/material";
import {
  BillPay_Patient_Relative_ChangeAccount,
  tBillPayModelWithItemCateInfo,
} from "src/app/models/tBillPayModel";
import { StatusMessage } from "src/app/shared/StatusMessage";
import { TranslateService } from "@ngx-translate/core";
import { MastersKeyStringValue } from "src/app/services/Non-Master/MastersKeyStringValue.service";
import { AppSettings } from "src/app/shared/AppSettings";
import { ApiResultDialogService } from "src/app/services/Non-Master/ApiResultDialog.service";
import { NULL_EXPR } from "@angular/compiler/src/output/output_ast";

@Component({
  selector: "app-bill-payment-change-account-dialog",
  templateUrl: "./bill-payment-change-account-dialog.component.html",
  styleUrls: ["./bill-payment-change-account-dialog.component.css"],
})
export class BillPaymentChangeAccountDialogComponent implements OnInit {
  TAG = "BillPaymentChangeAccountDialogComponent";

  editForm: FormGroup;
  submitted = false;

  @Input() patientID: string;
  @Input() tBillPayModelWithItemCateInfo: tBillPayModelWithItemCateInfo[];
  @Input() searchCase: number;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<BillPay_Patient_Relative_ChangeAccount>;
  dataList: BillPay_Patient_Relative_ChangeAccount[];

  displayedColumns: string[] = [
    // 'employeeID',
    "changeName",
    "creditLimit",
    // 'employeeLeaveStart',
    // 'employeeLeaveEnd',
  ];

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private tBillPayService: tBillPayService,
    private translate: TranslateService,
    private apiResultDialogService: ApiResultDialogService
  ) {
    const currentLanguage = localStorage.getItem("currentLanguage");
    translate.use(currentLanguage);
  }

  //loading spinner
  isLoading = true;
  onClickCounter: number = 0;



  ngOnInit() {
    if (this.searchCase == 1) {
      this.getDataWithRelativePatientID();
    }
  }

  getDataWithRelativePatientID(): void {
    this.isLoading = true;

    this.tBillPayService
      .getPatientRelativeChangeAccount(this.patientID)
      .subscribe(
        (data) => {
          this.dataList = data;
          this.dataSource =
            new MatTableDataSource<BillPay_Patient_Relative_ChangeAccount>();

          if (
            this.dataList[0].relativeChange !== null &&
            this.dataList[0].relativeChange !== undefined
          ) {
            this.dataSource =
              new MatTableDataSource<BillPay_Patient_Relative_ChangeAccount>(
                this.dataList
              );
          }

          // this.dataSource.paginator = this.paginator;

          //loading spinner
          this.isLoading = false;

          //table sort
          // this.dataSource.sort = this.sort;
        },
        (error) => (this.isLoading = false)
      );
  }

  cancel() {
    this.log.i(this.TAG, "do cancel");
    this.activeModal.close("Close click");
  }

  get f() {
    return this.editForm.controls;
  }

  selectedRecord(selectedModel: BillPay_Patient_Relative_ChangeAccount) {
    if (this.onClickCounter == 0) {
      this.log.i(this.TAG, "do selectedRecord");

      for (var p = 0; p < this.tBillPayModelWithItemCateInfo.length; p++) {
        this.tBillPayModelWithItemCateInfo[p].bpChangeID =
          selectedModel.relativeChange.changeID.toString();
      }

      this.tBillPayService
        .updateManyData(this.tBillPayModelWithItemCateInfo)
        .subscribe(
          (data: any) => {

            this.activeModal.close(data);
          },
          (err) => {
            console.error(err);
            let responseMessage = "Server Response Error";

            const errorCode = err.error.statusCode;
            const errorCustStatusCodes = ["ERORR_PAY_PRESCRIPTION_MISSING","ERORR_PAY_NON_POSITIVE_AMOUNT_IN_OUTSTANDING","ERORR_PAY_FINISHED_PAYMENT"];

            if (errorCode === StatusMessage.Status_BillPay_Prescription_Price_NotMatch) {
              this.translate
                .get("Message_BillPay_Prescription_Price_NotMatch")
                .subscribe((x) => (responseMessage = x));

            } else if (errorCustStatusCodes.find(x=>x===err.error.custStatusCode)) {
              this.translate
                .get(err.error.custStatusCode)
                .subscribe((x) => (responseMessage = x));
            }

            this.apiResultDialogService.openDialog(
              MastersKeyStringValue.ACTION_MessageDialog,
              null,
              MastersKeyStringValue.STATUS_FAIL,
              responseMessage
            );

            this.activeModal.close();
          }
        );
    }
    this.onClickCounter++;
  }
}
